import { CSSProperties, FC, ReactNode } from 'react'
import cn from './index.module.css'
import FieldWrapper from '../FieldWrapper/FieldWrapper'
import Tiptap from '@UI/Tiptap'
import tiptap from '@/components/pages/Admin/Surveys/common.module.css'
import classNames from 'classnames'

interface ITiptapField {
  label: string
  tooltip?: ReactNode
  value: string
  placeholder: string
  styles?: CSSProperties,
  className?: string
  contentCN?: string
  isInvalid?: boolean
  onChange: (value: string) => void
}

const TiptapField: FC<ITiptapField> = ({
  label,
  tooltip,
  value,
  placeholder,
  styles,
  className,
  contentCN,
  isInvalid,
  onChange,
}) => {
  return (
    <FieldWrapper
      label={label}
      tooltip={tooltip}
      isInvalid={isInvalid}
      className={className}
      styles={styles}
    >
      <Tiptap
        value={value}
        //@ts-ignore
        setValue={(value) => onChange(value)}
        tiptapClassContent={classNames(
          cn.tiptapContent,
          isInvalid && cn.invalid,
          contentCN,
        )}
        tiptapClassContentProseMirror={cn.tiptapClassContentProseMirror}
        placeholder={placeholder}
      />
    </FieldWrapper>
  )
}

export default TiptapField
